import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const useStyles = makeStyles(theme => ({
  icon: {
    color: theme.palette.primary.contrastText,
  },
}));

const WhiteIcon = ({ icon }) => {
  const classes = useStyles();
  return <FontAwesomeIcon icon={icon} className={classes.icon} />;
};

export default WhiteIcon;
